import React from "react";
import Video from "components/video";
import clsx from "clsx/lite";

const VideoModule = ({ data }) => {
	const { title, description, video, disableVideoAspectRatio } = data || {};

	return (
		<div className="flex flex-col text-left gap-4">
			{title && <h1 className="text-h2-xs leading-normal sm:text-h2">{title}</h1>}
			{description && <p className="text-base text-darkGray sm:text-lg">{description}</p>}
			<div className={clsx("w-full relative", disableVideoAspectRatio ? "object-cover" : "aspect-video")}>
				<Video data={ video } />
			</div>
		</div>
	);
};

export default VideoModule;
